import { render } from "./KSKandidati.vue?vue&type=template&id=c6faeacc&scoped=true&lang=html"
import script from "./KSKandidati.vue?vue&type=script&lang=js"
export * from "./KSKandidati.vue?vue&type=script&lang=js"

import "./KSKandidati.vue?vue&type=style&index=0&id=c6faeacc&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-c6faeacc"

export default script